import { getGlobalConfig } from '../config';
import { IDENTITIES_KEYS, IDENTITY_STATE, } from '../../types';
import { COOKIE } from '@iva/utils';
import { TIMEOUT } from '../consts';
import { createIdentityObject } from '../identities';
/**
 * Get udid value from cookie/s
 */
const _getUdidFromCookie = () => {
    const udidCookie = COOKIE.getCookie('udid');
    if (udidCookie) {
        const udidValueSplit = udidCookie.split('@');
        return udidValueSplit.length === 2 && udidValueSplit[0].length === 36 ? udidValueSplit[0] : udidCookie;
    }
    return null;
};
/**
 * Add udid to identitites object (if any)
 */
export const getUdid = (identities) => {
    const udid = _getUdidFromCookie();
    if (udid) {
        identities[IDENTITIES_KEYS.udid] = createIdentityObject(identities[IDENTITIES_KEYS.udid], udid, IDENTITY_STATE.fresh, true);
    }
};
/**
 * Listen to events emited by MARKER
 */
export const listenToMarker = (updater, getter) => {
    var _a, _b;
    const handler = () => {
        const existsInStorage = getter(IDENTITIES_KEYS.udid);
        const udid = _getUdidFromCookie();
        if (udid || existsInStorage) {
            const value = udid || existsInStorage.value;
            const state = udid ? IDENTITY_STATE.fresh : existsInStorage.state;
            updater({ udid: { value, state } });
        }
    };
    const udidTimer = window.setTimeout(() => {
        handler();
    }, ((_b = (_a = getGlobalConfig()) === null || _a === void 0 ? void 0 : _a.timeouts) === null || _b === void 0 ? void 0 : _b[IDENTITIES_KEYS.udid]) || TIMEOUT);
    const done = () => {
        window.clearTimeout(udidTimer);
        handler();
    };
    window.addEventListener('szn:marker:cookie', done);
};
